$(document).on "ready page:load", ->
  storeVisitorKey = (key) ->
    return if key == null || $.cookie("wistiaVisitorKey") == key
    $.ajax({
      url: "/api/v1/wistia_visitors",
      data: { visitor_key: visitorKey },
      method: "POST",
      headers: { "X-CSRF-Token": $( 'meta[name="csrf-token"]' ).attr( 'content' ) }
    }).always ->
      $.cookie("wistiaVisitorKey", key)
    return
  if(currentUser()?.id)
    visitorKey = Wistia.visitorKey.value()
    if visitorKey
      storeVisitorKey(visitorKey)
  return
